import { z } from "zod";

export const schema = z.object({
    servico_id: z.string().min(1, "Serviço é obrigatório"),
    unidade: z.string().min(1, "Unidade é obrigatória"),
    agendamento: z.boolean().default(false),
    atendimento: z.boolean().default(false),
});